import React from "react";

//import'./style.css';

const MedicalReport = (props) => {
  return (
    <React.Fragment>
      <svg
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 122.88 122.88"
        fill="currentColor"
      >
        <g>
          <path d="M50.59,0h21.7c3,0,5.72,1.22,7.69,3.19c1.97,1.97,3.19,4.69,3.19,7.69v28.83H112c3,0,5.72,1.22,7.69,3.19 c1.97,1.97,3.19,4.69,3.19,7.69v21.7c0,3-1.22,5.72-3.19,7.69c-1.97,1.97-4.69,3.19-7.69,3.19H83.17V112c0,3-1.22,5.72-3.19,7.69 c-1.97,1.97-4.69,3.19-7.69,3.19h-21.7c-3,0-5.72-1.22-7.69-3.19c-1.97-1.97-3.19-4.69-3.19-7.69V83.17H10.88 c-3,0-5.72-1.22-7.69-3.19C1.22,78.01,0,75.28,0,72.29v-21.7c0-3,1.22-5.72,3.19-7.69c1.97-1.97,4.69-3.19,7.69-3.19h28.83V10.88 c0-3,1.22-5.72,3.19-7.69C44.87,1.22,47.6,0,50.59,0L50.59,0z M72.29,7.03h-21.7c-1.06,0-2.02,0.43-2.72,1.14 c-0.7,0.7-1.14,1.66-1.14,2.72v32.34c0,1.94-1.57,3.51-3.51,3.51H10.88c-1.06,0-2.02,0.43-2.72,1.13c-0.7,0.7-1.14,1.66-1.14,2.72 v21.7c0,1.06,0.43,2.02,1.14,2.72c0.7,0.7,1.66,1.14,2.72,1.14h32.34c1.94,0,3.51,1.57,3.51,3.51V112c0,1.06,0.43,2.02,1.14,2.72 c0.7,0.7,1.66,1.14,2.72,1.14h21.7c1.06,0,2.02-0.43,2.72-1.14c0.7-0.7,1.13-1.66,1.13-2.72V79.66c0-1.94,1.57-3.51,3.51-3.51H112 c1.06,0,2.02-0.43,2.72-1.14c0.7-0.7,1.14-1.66,1.14-2.72v-21.7c0-1.06-0.43-2.02-1.14-2.72c-0.7-0.7-1.66-1.13-2.72-1.13H79.66 c-1.94,0-3.51-1.57-3.51-3.51V10.88c0-1.06-0.43-2.02-1.13-2.72C74.31,7.46,73.35,7.03,72.29,7.03L72.29,7.03z" />
        </g>
      </svg>
    </React.Fragment>
  );
};

export default MedicalReport;
